/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import NoChromeCheck from '@haptik/helpers/build/esm/noChromeCheck';

import ConfirmationDialog from 'components/ConfirmationDialog';
import Alert from 'components/Alert';
import ComponentModal from 'components/ComponentModal';
import { closeComponentModal } from 'actions/BotActions';
import ModalV2 from 'components/ModalV2';

import connection from '@src/connection';
import * as maps from './maps';

/**
 * Container that wraps all the global level popups that might exist
 * These include components such as the confirmation dialogs, global search,
 * alerts etc.
 * @type {Object}
 */
@connection(maps.listenToStores, maps.getStateFromStores)
export default class Utils extends React.Component {
  static propTypes = {
    meta: PropTypes.object,
    searchOverlayStatus: PropTypes.object,
    confirmationDialogStatus: PropTypes.object,
    alertStatus: PropTypes.object,
    componentModalStatus: PropTypes.object,
    componentTooltipStatus: PropTypes.object,
    editBotDialogStatus: PropTypes.object,
    partnerList: PropTypes.arrayOf(PropTypes.object),
    businessList: PropTypes.arrayOf(PropTypes.object),
  };

  render() {
    return (
      <>
        <ConfirmationDialog {...this.props.confirmationDialogStatus} />
        <Alert {...this.props.alertStatus} />
        <ModalV2
          classPrefix="componentModalV2"
          {...this.props.componentModalStatus}
          toggleModal={() => {
            closeComponentModal();
            this.props.componentModalStatus.onModalClose &&
              this.props.componentModalStatus.onModalClose();
          }}
        />
        <ComponentModal {...this.props.componentModalStatus} />
        <NoChromeCheck />
      </>
    );
  }
}
